<template>
    <section class="block-vido margin-both-lg container" :class="data.smaller_container ? 'container--medium' : ''">
        <VideoPopup @close="showHidePopup" :isOpen="popupOpen" v-if="videoBannerCanShow" :videoUrl="data.video" />
        <div class="inner" @click="showHidePopup">
            <div class="inner-elements" >
                <Button v-if="videoBannerCanShow" :outlined="false" :hasIcon="true" type="white" class="play-btn text-uppercase font--600">
                    Se filmen<span v-html="displayPlayButton()"/>
                </Button>
                <h2 v-if="data.title" class="titler dm" v-html="data.title"></h2>
                <div class="privacy_info_video" v-if="!videoBannerCanShow">Videoen vises ikke på grunn av personverninnstillingene dine.</div>
            </div>
            <div class="overlay"></div>
            <WpImage                 
                v-if="data.video_placeholder" 
                :image="data.video_placeholder"
                size="large"
                class="image_bg_video"
                background 
                cover
                />
            
        </div>
    </section>
</template>

<script>

import WpImage from '@/components/elements/WpImage'
import VideoPopup from '@/components/elements/VideoPopup'
import { play } from '@/components/../icons';
import Button from '@/components/elements/Button'
import { mapGetters } from 'vuex';

export default {
    name: 'vide-module',
    props: ['data'],
    data(){
        return {
            videoBannerCanShow: false,
            popupOpen: false,
        }
    },
    watch:{
        /* popupOpen(val){
            if(!this.YTPlayer){
                this.initYoutubePlayers()
            }
            if(val){
                this.playVideo();
                document.getElementsByTagName('html')[0].classList.add('popup-open')
            }else{
                this.pauseVideo();
                this.videoIsPlaying = false
                document.getElementsByTagName('html')[0].classList.remove('popup-open')
            }
        } */
    },
    beforeDestroy() {
        const VM = this;
        if(this.extendedCookies){
            window.removeEventListener('CookieInformationConsentGiven', VM.cookieSolution, false)
        }
    },
    mounted() {
        const VM = this;
        if(this.extendedCookies ){
            window.addEventListener('CookieInformationConsentGiven', VM.cookieSolution, false)
        }

        if(!this.extendedCookies){
            VM.videoBannerCanShow = true
        }
    },
    computed:{
        ...mapGetters([
        	'getOptions',
        ]),
        extendedCookies(){
            return this.getOptions.use_cookiesinformationcom
        }       
    },
    components:{
        WpImage,
        Button,
        VideoPopup
    },
    methods:{
        displayPlayButton(){
            return play();
        },
        showHidePopup(){
            this.popupOpen = !this.popupOpen;
        },
        cookieSolution(){
            const VM = this;
            if (CookieInformation && CookieInformation.getConsentGivenFor('cookie_cat_marketing')) { 
                VM.videoBannerCanShow = true
            }else{
                VM.videoBannerCanShow = false
            }
        },
    }
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.module-video_block{
    position: relative;

    .image_bg_video{
        z-index: 5;
    }
    .inner{
        padding-bottom: 56.4%;
        height: 0;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        &:hover{
            .playButton{
                svg{
                    transform: scale(1.1)
                }
                path{
                    fill: $green;
                }
            }
        }
        &.video-is-playing{
            .image_bg_video, .inner-elements, .overlay{
                opacity: 0;
                visibility: hidden;
            }
        }
    }
    .image_bg_video, .inner-elements, .overlay{
        transition: visibility 0.2s ease-in-out, opacity 0.2s ease-in-out;
        will-change: opacity, visibility;
    }
    .image_bg_video, .video-player iframe{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;  
        
    }
    
    .overlay{
//        background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, #000000 100%);
        background-image: linear-gradient(180deg, rgba(20,61,84,0.00) 0%, #143D54 100%);
        position: absolute;
        top: 50%;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 8;
    }
    .inner-elements{
        max-width: 600px;
        padding-left: 15px;
        padding-right: 15px;
        padding-bottom: 50px;
        margin-left: auto;
        margin-right: auto;
        color: #fff;
        z-index: 10;
        position: relative;
        text-align: center;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        @include mquery($tablet){
            padding-bottom: 40px;
        }
        @include mquery($phone){
            padding-bottom: 25px;
        }
        .titler{
            margin-top: 25px;
            margin-bottom: 15px;
            @include fluid-type($smallResText, $wideResText, 24px, 45px);
            @include mquery($tablet){
                margin-top: 15px;
                margin-bottom: 10px;
            }

        }
        .description{
            @include fluid-type($smallResText, $wideResText, 11px, 18px);
        }
    }
    .wp-image-vue .image{
        overflow: hidden; 
    }
}
</style>
